import React, { useContext } from "react";
import Banner from "./Banner.jsx";
import RequestButton from "./RequestButton.jsx";
import Applet from "./Applet.jsx";
import SiteContext from "./SiteContext.jsx";

export default function Dashboard() {
  const { applets, hasCrm } = useContext(SiteContext);

  return (
    <>
      <Banner />

      <div className='tw-p-7 tw-pt-4'>
        {hasCrm && <RequestButton />}

        <div className={hasCrm ? "tw-mt-4" : ""}>
          {applets.map((applet) => (
            <Applet key={applet.title} applet={applet} />
          ))}
        </div>
      </div>
    </>
  );
}
